// selectors.js
import { createSelector } from 'reselect';

const getMaterialData = (state) => state.MaterialData.material;
const getEmployeeData = (state) => state.EmployeeData.employee;
const getMatInwardData = (state) => state.MatInwardData.stkValue;

export const selectMaterials = createSelector(
  [getMaterialData],
  (material) => material || { data: [] }
);

export const selectEmployees = createSelector(
  [getEmployeeData],
  (employee) => employee || { data: [] }
);

export const selectMatInwardData = createSelector(
  [getMatInwardData],
  (stkValue) => stkValue || { data: [] }
);


